import { render, staticRenderFns } from "./news10.vue?vue&type=template&id=6ffe9d8a&scoped=true&"
import script from "./news10.vue?vue&type=script&lang=js&"
export * from "./news10.vue?vue&type=script&lang=js&"
import style0 from "./news10.vue?vue&type=style&index=0&id=6ffe9d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe9d8a",
  null
  
)

export default component.exports